import { BaseModel } from '../../../models/base-model'
import { QuestionContextType } from '../'

interface SentenceData {
  value: string
  paragraphStart: boolean
  paragraphEnd: boolean
}

export class QuestionContext extends BaseModel {
  public name: string
  public description: string
  public position: string
  public questionContextType: QuestionContextType
  public options: Array<any> = []

  public getContextSentences(): SentenceData[] {
    // Split on </p> or <br>
    const paragraphs = this.description.split(/<\/p>|<br(?:\s*\/\s*)?>/g)
    // Filter empty elements (trailing split)
    if (paragraphs[paragraphs.length - 1].trim() === '') {
      paragraphs.pop()
    }
    const sentences = paragraphs.reduce((allSentences, paragraph) => {
      const taglessParagraph = paragraph.replace(/<.*?>/g, '')
      const paragraphSentences = this._getSentences(taglessParagraph)
      const sentencesData = this._paragraphSentencesData(paragraphSentences)
      return [...allSentences, ...sentencesData]
    }, [])
    return sentences
  }

  private _getSentences(paragraph: string): string[] {
    // complete regEx: /["']?[A-Z][^.?!]+((?![.?!]['"]?\s+["']?[A-Z][^.?!]).)+[.?!'"]+/g

    // Matches begining of sentece up to before the punctuation:
    const beginOfSentenceUpToBeforeThePunctuation = `["']?[A-Z][^.?!]+`
    // Ensure that the next piece after the punctuation is not the beginning of the next sentence:
    const nextPieceAfterThePunctuationIsNotTheBeginningOfTheNextSentence = `((?![.?!]['"]?\\s+["']?[A-Z][^.?!]).)+`
    // Matches the punctiation:
    const punctuation = `[.?!'"]+`

    const sentenceRegex = new RegExp(
      beginOfSentenceUpToBeforeThePunctuation +
        nextPieceAfterThePunctuationIsNotTheBeginningOfTheNextSentence +
        punctuation,
      'g'
    )

    return paragraph.match(sentenceRegex) || []
  }

  private _paragraphSentencesData(paragraphSentences: string[]): SentenceData[] {
    const sentencesData = paragraphSentences.map((s) => {
      return { value: s.trim(), paragraphStart: false, paragraphEnd: false }
    })
    sentencesData[0].paragraphStart = true
    sentencesData[sentencesData.length - 1].paragraphEnd = true
    return sentencesData
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/question-context/question-context.ts